import { render } from "./CardInvoiceAccount.vue?vue&type=template&id=81673fbe&scoped=true"
import script from "./CardInvoiceAccount.vue?vue&type=script&lang=js"
export * from "./CardInvoiceAccount.vue?vue&type=script&lang=js"

import "./CardInvoiceAccount.vue?vue&type=style&index=0&id=81673fbe&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81673fbe"]])

export default __exports__